import { takeEvery, call, put, all, fork, spawn } from 'redux-saga/effects';

import { wcoxmlwebActions } from './actions';
import { wcoxmlwebService } from '../../services/wcoxmlweb';

import { onError } from '../../utils/onError';
import { downloadBlob } from '../../utils/downloadBlob';

function* exportWcoXmlWebConfigWatcher() {
  yield takeEvery(wcoxmlwebActions.EXPORT_WCOXML_CONFIG, function* ({ payload }) {
    try {
      let companyId = payload._id;
      const response = yield call(wcoxmlwebService.exportCompanyWcoXmlWebConfig, companyId);
      yield put(wcoxmlwebActions.exportWcoXmlConfigSuccess());
      yield spawn(downloadBlob, response, 'wcoxmlwebconfig');
    } catch (e) {
      yield put(wcoxmlwebActions.exportWcoXmlConfigFail(e));
      yield spawn(onError, e);
    }
  });
}

function* getWcoXmlDataWatcher() {
  yield takeEvery(wcoxmlwebActions.GET_WCOXML_WEB_DETAILS, function* ({ payload }) {
    const { companyId } = payload;
    try {
      const response = yield call(wcoxmlwebService.loadWcoXmlWebData, companyId);
      yield put(wcoxmlwebActions.getWcoXmlWebDetailsSuccess(response.data));
    } catch (e) {
      yield put(wcoxmlwebActions.getWcoXmlWebDetailsFail(e));
      yield spawn(onError, e);
    }
  });
}

export function* wcoxmlwebSaga() {
  yield all([fork(exportWcoXmlWebConfigWatcher), fork(getWcoXmlDataWatcher)]);
}
